import WebService from "../WebService";

const Question = {
  forms(params) {
    return WebService.get("/qa/form" + "?" + params);
  },
  updateForm(params) {
    return WebService.get("/qa/form" + "?" + params);
  },
  gets(params) {
    return WebService.get("/qa/form?" + params);
  },
  getAttendeeInfoForm(params) {
    return WebService.get("/qa/attendee-info-form?" + params);
  },
  get(form_id, params) {
    return WebService.get("/qa/form/" + form_id + "?" + params);
  },
  update(form_id, data) {
    return WebService.post(`/qa/form/${form_id}`, data);
  },
  getByuuid(form_uuid, params) {
    return WebService.get("/qa/form/" + form_uuid + "/uuid?" + params);
  },
  create(data) {
    return WebService.post("/qa/form", data);
  },
updateQuestionList(data) {
    return WebService.post("/qa/question-list", data);
  },
  getQuestions(params) {
    return WebService.get("/qa/question?" + params);
  },
  getQuestionsByUUID(params) {
    return WebService.get("/qa/question-by-uuid?" + params);
  },
  updateQuestion(data) {
    return WebService.post("/qa/question/" + data.question_id, data);
  },
  addQuestion(data) {
    return WebService.post("/qa/question", data);
  }
};
export default Question;
